export default {
      id: "tt-horizontal-rule-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.25bf3227.svg#tt-horizontal-rule",
      toString: function () {
        return this.url;
      }
    }